import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiFolder, FiHeart, FiList, FiPlus, FiSearch } from 'react-icons/fi';
import { prefetchHandlers } from '../../utils/prefetchRoute';
import '../VaultHubNav/VaultHubNav.css';

const MarketplaceHubNav = ({ layout = 'chips' }) => {
    const location = useLocation();
    const [isPhone, setIsPhone] = useState(false);
    const normalizedPath = location.pathname.toLowerCase();
    const searchParams = new URLSearchParams(location.search);
    const fromCollection =
        searchParams.get('fromCollection') === '1' || location.state?.pickFromCollection === true;
    const onMyListings = normalizedPath === '/mymarketplacelistings';
    const onBrowse = normalizedPath === '/marketplace';

    // Listings tab toggles Browse all ↔ My listings (label = where tap goes)
    const listingsTab = onMyListings
        ? {
              id: 'listings',
              to: '/marketplace',
              label: 'Browse all',
              shortLabel: 'Browse all',
              Icon: FiSearch,
              prefetch: '/marketplace',
              isActive: true,
          }
        : {
              id: 'listings',
              to: '/mymarketplacelistings',
              label: 'My listings',
              shortLabel: 'My listings',
              Icon: FiList,
              prefetch: '/mymarketplacelistings',
              isActive: onBrowse,
          };

    const items = [
        {
            id: 'create',
            to: '/createmarketplaceitem',
            label: 'Create listing',
            shortLabel: 'Create',
            Icon: FiPlus,
            prefetch: '/createmarketplaceitem',
            isActive: normalizedPath === '/createmarketplaceitem' && !fromCollection,
        },
        {
            id: 'collection',
            to: '/createmarketplaceitem?fromCollection=1',
            label: 'Sell from my collection',
            shortLabel: 'My collection',
            Icon: FiFolder,
            state: { pickFromCollection: true },
            prefetch: '/createmarketplaceitem',
            isActive: normalizedPath === '/createmarketplaceitem' && fromCollection,
        },
        listingsTab,
        {
            id: 'wishlist',
            to: '/myHeroCardWishList?type=marketplace',
            label: 'Wishlist',
            shortLabel: 'Wishlist',
            Icon: FiHeart,
            prefetch: '/myHeroCardWishList',
            isActive:
                normalizedPath === '/myherocardwishlist' && searchParams.get('type') === 'marketplace',
        },
    ];

    useEffect(() => {
        const mq = window.matchMedia('(max-width: 900px)');
        const sync = () => setIsPhone(mq.matches);
        sync();
        mq.addEventListener('change', sync);
        return () => mq.removeEventListener('change', sync);
    }, []);

    if (!isPhone) return null;

    return (
        <nav className={`msv-vault-hub-nav msv-vault-hub-nav--${layout}`} aria-label="Marketplace navigation">
            {items.map(({ id, to, label, shortLabel, Icon, state, prefetch, isActive }) => (
                <Link
                    key={id}
                    to={to}
                    state={state}
                    className={`msv-vault-hub-link${isActive ? ' is-active' : ''}`}
                    aria-current={isActive ? 'page' : undefined}
                    aria-label={label}
                    title={label}
                    {...(prefetch ? prefetchHandlers(prefetch) : {})}
                >
                    {Icon && <Icon className="msv-vault-hub-icon" aria-hidden />}
                    <span className="msv-vault-hub-label">{label}</span>
                    <span className="msv-vault-hub-short-label">{shortLabel || label}</span>
                </Link>
            ))}
        </nav>
    );
};

export default MarketplaceHubNav;
